import { styled } from 'dripsy';
import React from 'react';
import { View } from 'react-native';

import { BaseText } from '../../common/BaseText';
import { Touchable } from '../../common/Touchable';
import { Icon } from '../../common/Icon';

const Container = styled(Touchable)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 50,
});

const Text = styled(BaseText)({
  color: '$heading800',
  variant: 'text.medium',
});

interface IIconContainerStyleProps {
  isActive?: boolean;
}

const IconContainer = styled(View)(
  (props: IIconContainerStyleProps) => ({
    justifyContent: 'center',
    alignItems: 'center',
    size: 20,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: props.isActive ? '$primary300' : '$text400',
    backgroundColor: props.isActive ? '$primary300' : '$background0',
  }),
);

export type DropDownItemOptionType = {
  value: any;
  title: string;
};

export interface IDropDownItemProps {
  option: DropDownItemOptionType;
  onPress(option: DropDownItemOptionType): void;
  isActive?: boolean;
}

export function DropDownItem({
  option,
  onPress,
  isActive,
}: IDropDownItemProps) {
  function onPressInner() {
    onPress(option);
  }

  return (
    <Container onPress={onPressInner}>
      <Text>{option.title}</Text>
      <IconContainer isActive={isActive}>
        {isActive && (
          <Icon name="done-light" color="$background0" size={16} />
        )}
      </IconContainer>
    </Container>
  );
}
